import React from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'

import { useMutation } from '@apollo/client'
import { Button, Dialog, Divider, Zoom } from '@material-ui/core'

import { UserContext } from '../../App'
import { DELETE_POST, UNFOLLOW_USER } from '../../graphql/mutations'
import { useOptionsDialogStyles } from '../../styles'

function OptionsDialog({ onClose, authorId, postId, modalOpen }) {
  const classes = useOptionsDialogStyles()
  const { currentUserId, followingIds } = React.useContext(UserContext)
  const isOwner = authorId === currentUserId
  const buttonText = isOwner ? 'Delete' : 'Unfollow'
  const onClick = isOwner ? handleDeletePost : handleUnfollowUser
  const isFollowing = followingIds.some(id => id === authorId)
  const isUnrelatedUser = !isOwner && !isFollowing
  const [unfollowUser] = useMutation(UNFOLLOW_USER)
  const [deletePost] = useMutation(DELETE_POST)
  const history = useHistory()
  const location = useLocation()
  const postAlreadyOpen = location.pathname.includes(`/p/${postId}`)

  async function handleDeletePost() {
    const variables = {
      postId,
      userId: currentUserId
    }
    await deletePost({ variables })
    onClose()
    history.push('/')
    window.location.reload()
  }

  function handleUnfollowUser() {
    const variables = {
      userIdToFollow: authorId,
      currentUserId
    }
    unfollowUser({ variables })
    onClose()
  }

  async function handleCopyLink() {
    await navigator.clipboard.writeText(`${window.location.origin}/p/${postId}`)
    onClose({ linkCopied: true })
  }

  return (
    <Dialog
      open
      classes={{ scrollPaper: classes.dialogScrollPaper }}
      onClose={onClose}
      TransitionComponent={Zoom}
    >
      {!isUnrelatedUser && (
        <Button onClick={onClick} className={classes.redButton}>
          {buttonText}
        </Button>
      )}
      <Divider />
      {(!postAlreadyOpen || modalOpen) && (
        <Button className={classes.button}>
          <Link style={{ width: '100%' }} to={`/p/${postId}`}>
            Go to post
          </Link>
        </Button>
      )}
      <Divider />
      <Button className={classes.button}>Share</Button>
      <Divider />
      <Button onClick={handleCopyLink} className={classes.button}>
        Copy Link
      </Button>
      <Divider />
      <Button className={classes.button} onClick={onClose}>
        Cancel
      </Button>
    </Dialog>
  )
}

export default OptionsDialog
